export const manifest = {
  screens: {
    scr_yhdz56: { name: "Home", route: "/" },
  },
}
